import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import PageAddCategory from '../../pages/Categories/Add';

const ModalAddCategory = props => {
  const { handleModalClose, showModal } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddCategory handleModalClose={handleModalClose} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddCategory.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool
};

export default ModalAddCategory;
